import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
};

const invoicesSlice = createSlice({
  name: 'invoices',
  initialState,
  reducers: {
    cancelInvoiceRequest(state) {
      state.loading = true;
      state.error = null;
    },
    cancelInvoiceSuccess(state) {
      state.loading = false;
      state.error = null;
    },
    cancelInvoiceFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    transmitInvoiceToPeppolRequest(state) {
      state.loading = true;
      state.error = null;
    },
    transmitInvoiceToPeppolSuccess(state) {
      state.loading = false;
    },
    transmitInvoiceToPeppolFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  cancelInvoiceRequest,
  cancelInvoiceSuccess,
  cancelInvoiceFailure,
  transmitInvoiceToPeppolRequest,
  transmitInvoiceToPeppolSuccess,
  transmitInvoiceToPeppolFailure,
} = invoicesSlice.actions;

export default invoicesSlice.reducer;
